import { render, staticRenderFns } from "./AdminWorkshopStockOrdersScreen.vue?vue&type=template&id=06114a71&scoped=true&"
import script from "./AdminWorkshopStockOrdersScreen.vue?vue&type=script&lang=js&"
export * from "./AdminWorkshopStockOrdersScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkshopStockOrdersScreen.vue?vue&type=style&index=0&id=06114a71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06114a71",
  null
  
)

export default component.exports